import {columnsByType, hiddenConditions, conditionSortConfig} from "./table-configuration";

const conditionNameCollator = new Intl.Collator(undefined, {
    sensitivity: 'base',
    numeric: true
});

const conditionNameComparator = (left, right) => {
    return conditionNameCollator.compare(left, right);
};

// Applies relative ordering rules after the base alphabetical sort.
// If either the condition or anchor is missing, the original order is kept.
const applyPlaceAfterRules = (sortedConditionNames) => {
    const placeAfterRules = conditionSortConfig.placeAfterRules || [];
    const names = [...sortedConditionNames];

    for (const rule of placeAfterRules) {
        const conditionIndex = names.findIndex((name) => rule.conditionPattern.test(name));
        const anchorIndex = names.findIndex((name) => rule.anchorPattern.test(name));
        if (conditionIndex === -1 || anchorIndex === -1) continue;
        if (conditionIndex === anchorIndex + 1) continue;

        const [conditionName] = names.splice(conditionIndex, 1);
        const updatedAnchorIndex = names.findIndex((name) => rule.anchorPattern.test(name));
        names.splice(updatedAnchorIndex + 1, 0, conditionName);
    }

    return names;
};

const processDataToList = (conditionData) => {
    let rows = [];

    for (let car of conditionData) {
        if (car.bogies) {
            for (let bogie of car.bogies) {
                for (let category of bogie.categories) {
                    for (let asset of category.assets) {
                        const timestamp = asset.lastDataTimestamp ? asset.lastDataTimestamp : car.lastDataTime;
                        const ci_values = asset.ci_values ? asset.ci_values : [];
                        rows.push({
                            status: asset.status,
                            car: `${car.carId}`,
                            bogie: formatAssetName(bogie.name + ' ' + bogie.ordinal),
                            wheel: formatAssetName(asset.name),
                            lastDataTimestamp: timestamp,
                            conditions: ci_values.map(ci_value => {
                                return {
                                    name: ci_value.name,
                                    value: ci_value.results[0].value.toFixed(2),
                                    unit: ci_value.unit,
                                    status: ci_value.status,
                                    ci_value: ci_value
                                };
                            }),
                            asset: asset,
                            subsystem: category
                        });
                    }
                }
            }
        }
    }
    return rows;
};

const formatAssetName = name => {
    if (name.startsWith('AXLE-HEAD')) name = name.replaceAll(/AXLE-HEAD/g, 'WHEEL');
    let lowerCased = name.includes('HVAC') ? name :  name.toLowerCase();
    lowerCased = lowerCased.replaceAll(/-/g, ' ');
    return name.toUpperCase().charAt(0) + lowerCased.substring(1);
};

// For figuring out ci based table headers
function getUniqueConditionNames(data) {
    const uniqueConditions = [];
    for (let row of data) {
        for (let condition of row.conditions) {
            if (!uniqueConditions.includes(condition.name)) {
                uniqueConditions.push(condition.name);
            }
        }
    }
    const sortedConditionNames = uniqueConditions
        .filter(conditionName => !hiddenConditions.includes(conditionName))
        .sort(conditionNameComparator);

    return applyPlaceAfterRules(sortedConditionNames);
}

const formatForExport = (data, tab) => {
    const columns = columnsByType[tab];
    const toExport = {
        headers: [],
        content: []
    };

    const uniqueConditions = getUniqueConditionNames(data);

    function addHeaders() {
        if (columns.status) toExport.headers.push('Status');
        if (columns.car) toExport.headers.push('Car');
        if (columns.bogie) toExport.headers.push('Bogie');
        if (columns.wheel) toExport.headers.push('Asset');
        if (columns.lastDataTimestamp) toExport.headers.push('Last data received');
        toExport.headers.push(...uniqueConditions);
    }

    function addContent() {
        for (let element of data) {
            const row = [];
            if (columns.status) row.push(element.status);
            if (columns.car) row.push(element.car);
            if (columns.bogie) row.push( element.bogie);
            if (columns.wheel) row.push(element.wheel);
            if (columns.lastDataTimestamp) row.push(element.lastDataTimestamp);
            uniqueConditions.map((conditionName, index) => {
              const condition = element.conditions.find(condition => condition.name === conditionName);
              return condition ? condition.value + ' ' + condition.unit : '.';
            }).forEach(value => row.push(value));
            toExport.content.push(row);
        }
    }

    addHeaders();
    addContent();
    return toExport;
};

export {processDataToList, getUniqueConditionNames, formatForExport};